<template>
  <div>
    <form-field-input
        label="Label"
        v-model="form.label"
        :validation-errors="validationErrors.label"
        help-text="Changing this will not affect the existing data, it will only change the label of the data"
    ></form-field-input>

    <form-field-select
        label="Field Order"
        v-model="form.order"
        :validation-errors="validationErrors.order"
    >
      <option v-for="customField in customFields" :value="customField.order">{{customFieldLabel(customField)}}</option>
      <!-- Show this end option if creating -->
      <option v-if="formData.order === undefined" :value="customFields.length + 1">At End</option>
    </form-field-select>

    <form-field-select
        v-if="!formData.id"
        label="Type"
        v-model="form.type"
        :validation-errors="validationErrors.type"
    >
      <option :value="null">Select Type</option>
      <option v-for="option in ENUMS.CustomFieldTypeEnum" :value="option.value">{{option.label}}</option>
    </form-field-select>

    <form-field-collection
      v-if="typeHasOptions"
      label="Options"
      placeholder="create options"
      icon="label"
      v-model="form.options"
      :validation-errors="validationErrors.options"
      :allow-new="true"
    ></form-field-collection>

    <!-- Default Values for all the different types -->

    <!-- Number -->
    <form-field-input
      v-if="form.type === ENUMS.CustomFieldTypeEnum.Number.value"
      label="Default Value"
      v-model="form.default_value"
      :validation-errors="validationErrors.default_value"
      type="number"
    ></form-field-input>

    <!-- Currency -->
    <form-field-currency
      v-else-if="form.type === ENUMS.CustomFieldTypeEnum.Currency.value"
      label="Default Value"
      v-model="form.default_value"
      :validation-errors="validationErrors.default_value"
    ></form-field-currency>

    <!-- Email -->
    <form-field-input
      v-else-if="form.type === ENUMS.CustomFieldTypeEnum.Email.value"
      label="Default Value"
      v-model="form.default_value"
      :validation-errors="validationErrors.default_value"
      type="email"
    ></form-field-input>

    <!-- Phone -->
    <form-field-phone
      v-else-if="form.type === ENUMS.CustomFieldTypeEnum.Phone.value"
      label="Default Value"
      v-model="form.default_value"
      :validation-errors="validationErrors.default_value"
    ></form-field-phone>

    <!-- Textarea -->
    <form-field-textarea
      v-else-if="form.type === ENUMS.CustomFieldTypeEnum.TextArea.value"
      label="Default Value"
      v-model="form.default_value"
      :validation-errors="validationErrors.default_value"
    ></form-field-textarea>

    <!-- Date -->
    <form-field-date-picker
      v-else-if="form.type === ENUMS.CustomFieldTypeEnum.Date.value"
      label="Default Value"
      v-model="form.default_value"
      :validation-errors="validationErrors.default_value"
      is-inline
      has-clear-button
    ></form-field-date-picker>

    <!-- Time -->
    <form-field-time-picker
      v-else-if="form.type === ENUMS.CustomFieldTypeEnum.Time.value"
      label="Default Value"
      v-model="form.default_value"
      :validation-errors="validationErrors.default_value"
      type="time"
      is-inline
    ></form-field-time-picker>

    <!-- Standard Input -->
    <form-field-input
      v-else
      label="Default Value"
      v-model="form.default_value"
      :validation-errors="validationErrors.default_value"
    ></form-field-input>

    <form-field-switch
      label="Visible When Collapsed"
      v-model="form.visible"
      :validation-errors="validationErrors.visible"
      description="Turn on if you want this field to be visible on Lead Info section when it is collapsed"
    ></form-field-switch>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {ENUMS} from "../services/enums";

export default {
  name: "CustomFieldForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        id: null,
        label: '',
        type: ENUMS.CustomFieldTypeEnum.Text.value,
        default_value: null,
        options: [],
        custom_fieldable_type: null, // Must be provided by parent
        custom_fieldable_id: '',     // Must be provided by parent
        order: 0,
        visible: false
      },
    }
  },
  created() {
    if (! this.formData || ! this.formData.custom_fieldable_type) {
      throw new Error('You must provide the custom_fieldable_type and custom_fieldable_id as formData');
    }

    if (!this.formData.order) {
      this.defaultForm.order = this.customFields.length + 1;
    }

    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  computed: {
    customFields() {
      return this.$store.getters.customFields(this.formData.custom_fieldable_type, this.formData.custom_fieldable_id);
    },
    typeHasOptions() {
      return [
        // ENUMS.CustomFieldTypeEnum.Text.value,
        // ENUMS.CustomFieldTypeEnum.Number.value,
        // ENUMS.CustomFieldTypeEnum.Date.value,
        // ENUMS.CustomFieldTypeEnum.Time.value,
        ENUMS.CustomFieldTypeEnum.DropDown.value,
        // ENUMS.CustomFieldTypeEnum.Url.value,
        // ENUMS.CustomFieldTypeEnum.TextArea.value,
        // ENUMS.CustomFieldTypeEnum.Phone.value,
        // ENUMS.CustomFieldTypeEnum.Email.value,
        // ENUMS.CustomFieldTypeEnum.Currency.value,
      ].includes(this.form.type);
    }
  },
  methods: {
    customFieldLabel(customField) {
      // Creating
      if (this.formData.order === undefined) {
        return 'Before ' + customField.label;
      }

      // Updating
      if (this.formData.order > customField.order) {
        return 'Before ' + customField.label;
      }

      if (this.formData.order < customField.order) {
        return 'After ' + customField.label;
      }

      return 'Current Position';
    },
    update() {
      return this.$api.customFields.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Custom field was updated',
            type: 'is-success'
          });

            return res;
          });
    },
    create() {
      return this.$api.customFields.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Custom field was created',
            type: 'is-success'
          });

            return res;
          });
    },
    delete() {
      return this.$api.customFields.delete(this.form.id)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Custom field was archived',
            type: 'is-success'
          });

          return res;
        });
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
